
import { defineComponent } from 'vue';
import userApi from '@/api/account';
import { Cookies } from '@/utils';

import { power, userInfo } from '@/store';

export default defineComponent({
	name: 'index',
	// 数据
	data() {
		return {
			form: {
				userName: '',
				passWord: '',
			},
			showDatabase: false,
			backClass: 'bg'+1,
		};
	},

	// 传值
	props: [],

	// 计算
	computed: {
		
	},

	// 组件
	components: {},

	// 方法
	methods: {
		async do_login() {
			const res = await userApi.login(this.form);
			if (res.code === 0) {
				// 缓存用户信息
				const resInfo = res.request;
				Object.assign(userInfo, resInfo);
				Cookies.set('userName', resInfo.userName);
				Cookies.set('userId', resInfo.userId);
				Cookies.set('editMedia', resInfo.editMedia);
				Cookies.set('editUser', resInfo.editUser);
				power.editMedia = resInfo.editMedia == 1;
				power.editUser = resInfo.editUser == 1;

				await this.$router.push('media-list');
			}
		},
		getBackActive() {
			// 取1-16的一个数据整数
			let num = Math.floor(Math.random() * 16) + 1;
			return 'bg' + num;
		}
	},

	// 生命周期
	created() {
		document.onkeypress = (e) => {
			const keycode = document.all ? e.keyCode : e.which;
			if (keycode === 13) {
				this.do_login();
				return false;
			}
		};

		this.backClass = this.getBackActive();

		const val = localStorage.getItem('activeBack');
		if (val && val !== '0') this.backClass = 'bg'+val;
	},
});
